// Angular
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

// Formly
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-form-horizontal',
    templateUrl: './form-horizontal.wrapper.component.html',
    styleUrls: ['./form-horizontal.wrapper.component.scss'],
})
export class FormHorizontalWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { static: true, read: ViewContainerRef }) fieldComponent: ViewContainerRef;

    public errorColWidth = 0;

    public getLabel(label: string): string {
        if (label === '_') {
            return ' ';
        }

        return label;
    }

    public getRequired(label: string): string {
        if (label === '_') {
            return ' ';
        }

        return '*';
    }

    public getLabelClass(className: string, defaultClass: string) {
        return className ? className : defaultClass;
    }

    public calcValueClass(className: string, defaultClass: string): string {
        if (this.to.label === '') {
            return 'col-sm-12';
        }

        if (className && className.indexOf('col-') === 0) {
            const defaultClassArr = defaultClass.split('-');
            const classArr = className.split('-');
            const defaultclassColWidth = parseInt(defaultClassArr[defaultClassArr.length - 1], 10);
            const classColWidth = parseInt(classArr[classArr.length - 1], 10);

            return 'col-sm-' + (12 - classColWidth - this.errorColWidth);
        }

        return defaultClass;
    }
}
